import { Locale, format as jFormat, newDate } from "date-fns-jalali";

import { format, isToday, isYesterday } from "date-fns";

interface IDateFormatter {
  lang: "fa" | "en";
  date: Date | string;
}
interface IDateFormatterTimestamp {
  lang: string;
  timestamp?: number;
}
export function dateFormatter({ lang, date }: Readonly<IDateFormatter>) {
  const time = format(date, "HH:mm:ss");
  return lang == "fa"
    ? jFormat(date, ` ${time}  yyyy-MM-dd`)
    : format(date, "yyyy/MM/dd");
}

const day = {
  fa: { today: "امروز", yesterday: "دیروز" },
  en: { today: "today", yesterday: "yesterday" },
};

export function formatDateWithTime({ lang, date }: Readonly<IDateFormatter>) {
  const time = format(date, "HH:mm:ss");
  if (isToday(date)) {
    return `${day[lang].today}  ${time}`;
  } else if (isYesterday(date)) {
    return `${day[lang].yesterday}  ${time}`;
  } else {
    const jDate = jFormat(date, "yyyy/MM/dd");
    return `${jDate} , ${time}`;
  }
}

export function formatTimestampWithTime({ lang, timestamp }: Readonly<IDateFormatterTimestamp>) {
  if(!timestamp) return "";
  const date = new Date(timestamp < 1e12 ? timestamp * 1000 : timestamp);

  const time = format(date, "HH:mm:ss");

  if (isToday(date)) {
    return `${day[lang].today}  ${time}`;
  } else if (isYesterday(date)) {
    return `${day[lang].yesterday}  ${time}`;
  } else {
    const jDate = jFormat(date, "yyyy/MM/dd");
    return `${jDate} , ${time}`;
  }
}